import type React from 'react';
import { Close } from '@shared/assets';
import type { Author } from '@shared/types/defaults';
import { IconButton } from '@shared/ui';
import { useProgramQuery } from '@src/api/api-hooks/programs/useProgramQuery.ts';
import { Loader, ModalMiddle } from 'library/components/common';
import { useProgramBuy, useProgramModalBuyState } from './model';
import * as st from './styles.module.scss';

// const value = '1';
// const periods = [
//   { value: '0', forUser: '123' },
//   { value: '1', forUser: 'awd' },
//   { value: '2', forUser: 'dbb' },
//   { value: '3', forUser: 'zsc' },
//   { value: '4', forUser: '123' },
//   { value: '5', forUser: '123' },
//   { value: '6', forUser: '123' },
//   { value: '7', forUser: '123' },
// ];
export const ModalBuy: React.FC = () => {
  const { modalState, doCloseModal } = useProgramModalBuyState();
  // const { data: documents } = useGetAllDocumentsQuery(undefined);
  // const { doSavePageUrl } = useDocumentViewerPagesRedirect();

  const { data: program } = useProgramQuery({
    id: modalState?.programId ? String(modalState?.programId) : undefined,
  });

  // const { data: paymentVariants } = useGetPaymentVariantsQuery(undefined);

  const { buyProgram, isProcessing } = useProgramBuy();
  const onClose = () => {
    // navigate(-1);
    doCloseModal();
  };

  // const [isTagSelected, setIsTagSelected] = useState(false);

  const getName = (author?: Author) => {
    let name = '';
    if (author) {
      const { last_name, first_name, middle_name } = author;

      name = `${last_name} ${first_name} ${middle_name ?? ''}`;
    }
    return name;
  };

  const onBuy = async () => {
    if (modalState?.programId) {
      buyProgram(modalState?.programId);
    }
  };

  return (
    <ModalMiddle
      isOpen={modalState?.isOpen}
      close={onClose}
      onRequestClose={onClose}
      className={st.modal}
    >
      <section className={st.head}>
        <button className={st.head__close} onClick={onClose}>
          <IconButton variant="white">
            <Close />
          </IconButton>
        </button>
        <h3>Доступ к видеопрограмме</h3>
      </section>

      {!program && (
        <div className={st.wrapper}>
          <Loader />
        </div>
      )}
      {program && (
        <>
          <section className={st.data}>
            <div className={st.data__row}>
              <div className={st.data__title}>Программа</div>
              <div className={st.data__field}>{program?.title}</div>
            </div>
            <div className={st.data__row}>
              <div className={st.data__title}>Автор</div>
              <div className={st.data__field}>{getName(program?.author)}</div>
            </div>
            {program.access_duration.days !== 0 && (
              <div className={st.data__row}>
                <div className={st.data__title}>Доступ</div>
                <div className={st.data__field}>{program.access_duration.title}</div>
              </div>
            )}

            {/* <div className={st.data__row}>
              <div className={st.data__title}>Промокод</div>
              <input className={st.data__promo} />
              <button className={st.data__promo__button}>Применить</button>
            </div> */}
            <div className={st.data__row}>
              <div className={st.data__title}>Стоимость</div>
              <div className={st.data__field}>
                {/* {(user?.is_coach ? program?.cost_base : program?.cost_base) / 100} <span>RUB</span> */}
                {program?.cost} <span>RUB</span>
              </div>
            </div>

            {/*<div className={st.data__row}>*/}
            {/*  <div className={st.data__title}>Способ рассрочки</div>*/}
            {/*  <Select values={periods} value={value} fullWidth />*/}
            {/*</div>*/}

            {/*<fieldset className={st.access}>*/}
            {/*  <div className={st.access__header}>*/}
            {/*    <h3>Доступ</h3>*/}
            {/*  </div>*/}
            {/*  /!*<Card className={st.card}>*!/*/}
            {/*  <div className={st.access__dropdown}>*/}
            {/*    <div className={st.period}>*/}
            {/*      <div*/}
            {/*        className={cn(st.period__field)}*/}
            {/*        onClick={onOpen}*/}
            {/*        ref={setReferenceEl}*/}
            {/*      >*/}
            {/*        <span>{value ? periods.find((period) => period.value === value)?.label : ''}</span>*/}
            {/*        <div className={st.icon}>*/}
            {/*          <ArrowDown />*/}
            {/*        </div>*/}
            {/*      </div>*/}
            {/*      <MenuDropdown*/}
            {/*        popperEl={popperEl}*/}
            {/*        referenceEl={referenceEl}*/}
            {/*        setPopperEl={setPopperEl}*/}
            {/*        offset={[0, 0]}*/}
            {/*        dropdownClasses={st.period__dropdown}*/}
            {/*      >*/}
            {/*        {periods?.length ? (*/}
            {/*          periods.map((period) => (*/}
            {/*            <MenuItem*/}
            {/*                key={period.value}*/}
            {/*                onClick={(e) => {*/}
            {/*                  onMenuClose(e);*/}
            {/*                  // onChange(period.value);*/}
            {/*                }}*/}
            {/*                // onBlur={onBlur}*/}
            {/*                className={st.period__item}*/}
            {/*              >*/}
            {/*                {period.label}*/}
            {/*              </MenuItem>*/}
            {/*            ))*/}
            {/*          ) : (*/}
            {/*            <Loader />*/}
            {/*          )}*/}
            {/*        </MenuDropdown>*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    /!*<p className={st.access__subtitle}>Доступность видеопрограммы после ее оплаты</p>*!/*/}
            {/*  /!*</Card>*!/*/}
            {/*</fieldset>*/}

            {/*<div className={st.tag}>*/}
            {/*  <IconCheckbox*/}
            {/*    checked={isTagSelected}*/}
            {/*    onClick={() => setIsTagSelected(!isTagSelected)}*/}
            {/*  />*/}
            {/*  <div className={st.agree}>*/}
            {/*    <span>Я прочитал, понял и принимаю </span>*/}
            {/*    <u>*/}
            {/*      <Link className={st.agree__link} to={`/${documents?.agreement?.id}`} onClick={doSavePageUrl}>*/}
            {/*        условия просмотра видеопрограммы*/}
            {/*      </Link>*/}
            {/*      /!*<span className={st.agree__link} onClick={() => navigate(`/${String(documents?.agreement?.id)}`)}>*!/*/}
            {/*      /!*  условия просмотра видеопрограммы*!/*/}
            {/*      /!*</span>*!/*/}
            {/*    </u>*/}
            {/*  </div>*/}
            {/*</div>*/}
          </section>
          <section className={st.submit}>
            <button
              disabled={
                isProcessing
                // || !isTagSelected
              }
              type="button"
              className={st.submit__button}
              onClick={onBuy}
            >
              Далее
            </button>
          </section>
        </>
      )}
    </ModalMiddle>
  );
};
